export const FORTHCODE_SERVER_IP = "34.90.235.14";

// Error code: Failed to fetch API keys
export const ERROR_FETCH_API_KEYS = "FTF";
// Error code: New IP address is not provided
export const ERROR_NEW_IP_NOT_PROVIDED = "NTA";
// Error code: IP address already added
export const ERROR_IP_ALREADY_ADDED = "IAA";
// Error code: Failed to add IP address
export const ERROR_FAILED_TO_ADD_IP = "FTA";
// Error code: Failed to remove IP address
export const ERROR_FAILED_TO_REMOVE_IP = "FTR";
// Error code: Failed to add sender number
export const ERROR_FAILED_TO_ADD_SENDER = "FTS";
// Error code: Failed to set selected sender number
export const ERROR_FAILED_TO_SET_SENDER = "FTSS";
// Error code: Failed to set callback URL
export const ERROR_FAILED_TO_SET_CALLBACK = "FTSC";
// Error code: Failed to add API key
export const ERROR_FAILED_TO_ADD_API_KEY = "FTAC";